import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrderTypeGuard } from './guards/order-type.guard';
import { OrderTimeGuard } from './guards/order-time.guard';
import { RestaurantNotFoundGuard } from './guards/restaurant-not-found.guard';

const routes: Routes = [
  {
    path: 'type',
    loadChildren: () => import('./order-type/order-type.module').then((m) => m.OrderTypeModule),
    canActivate: [OrderTimeGuard],
  },
  {
    path: 'closed',
    loadChildren: () => import('./restaurant-closed/restaurant-closed.module').then((m) => m.RestaurantClosedModule),
    canActivate: [OrderTimeGuard],
  },
  {
    path: 'not-found',
    canActivate: [RestaurantNotFoundGuard],
    loadChildren: () =>
      import('./restaurant-not-found/restaurant-not-found.module').then((m) => m.RestaurantNotFoundModule),
  },
  {
    path: 'orders',
    loadChildren: () => import('./order-list/order-list.module').then((m) => m.OrderListModule),
  },
  {
    path: 'location',
    loadChildren: () => import('./location/location.module').then((m) => m.LocationModule),
    data: { animation: 'DeliveryLocation' },
  },
  {
    path: 'delivery/:zipCode',
    loadChildren: () => import('./product-list/product-list.module').then((m) => m.ProductListModule),
    canActivate: [OrderTypeGuard],
  },
  {
    path: 'take-away',
    loadChildren: () => import('./product-list/product-list.module').then((m) => m.ProductListModule),
    canActivate: [OrderTypeGuard],
  },
  { path: '', redirectTo: 'type', pathMatch: 'full' },
  { path: '**', redirectTo: 'type' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
